/* Shared test-call helper for the new UI (script editor + Testing page).
   Places an outbound call through the V2/TEN outbound endpoint, running the given
   script — the same request the legacy "Test Agent" call and the script editor use. */
import { getOutboundCallUrl, getCurrentUserIdForCalls } from '../../lib/apiConfig';
import { AGENT_VOICE_OPTIONS as VOICE_OPTIONS } from '../../constants/agentVoices';

export const DEFAULT_FROM_NUMBER = '(805) 500-0806';

export async function placeTestCall({
  scriptData,
  to,
  firstName = '',
  lastName = '',
  ttsEngine = 'kokoro',
  voiceId,
  agentId,
  from = DEFAULT_FROM_NUMBER,
}) {
  const digits = String(to || '').trim().replace(/\D/g, '');
  if (!digits) throw new Error('Enter a destination phone number.');
  if (!scriptData) throw new Error('Select a Customer AI to test.');

  const token = localStorage.getItem('token');
  const placedByUserId = getCurrentUserIdForCalls();
  const sd = {
    ...scriptData,
    firstName: firstName.trim() || scriptData.firstName || null,
    lastName: lastName.trim() || scriptData.lastName || null,
  };
  const body = {
    to: String(to).trim(),
    from,
    stack: 'kokoro-vad',
    preferBodyScript: true,
    ...(placedByUserId ? { placedByUserId } : {}),
    scriptData: sd,
    fileId: null,
    // Agent-based test: let the agent drive script + KB + voice/STT/TTS (like inbound). Only send
    // the manual voice params when no agent is selected.
    ...(agentId
      ? { agentId }
      : { voiceId: voiceId || scriptData.settings?.voiceId || VOICE_OPTIONS[0].id, ttsProvider: ttsEngine }),
    useTen: true, // route audio through the TEN framework server (matches legacy "Start call")
  };

  const res = await fetch(getOutboundCallUrl(), {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
    body: JSON.stringify(body),
  });
  const raw = await res.text();
  let data = null;
  try {
    data = raw ? JSON.parse(raw) : null;
  } catch {
    throw new Error('Server returned an invalid response.');
  }
  if (res.ok && data?.success) return data;
  throw new Error(data?.message || 'Failed to start call.');
}
